export default {
  back: 'Zpět',

  navigation: {
    orders: 'Zpracování',
    customers: 'Zákazníci',
    packetaShipments: 'Příjem Zásilkovny',
    checkedFiles: 'Provedené kontroly',
  },

  user: {
    login: 'Přihlásit se',
    logout: 'Odhlásit se',
    logForm: 'Přihlašovací formulář',
    activationForm: 'Aktivační formulář',
    resetPasswordConfirmForm: 'Potvrzovací formulář pro obnovu hesla',
    activation: 'Aktivovat',
    passwordChange: 'Změnit heslo',
    forgottenPassword: 'Zapomenuté heslo',
    password: 'Heslo',
    passwordConfirm: 'Potvrzení hesla',
  },

  orders: {
    detail: 'Detail objednávky {0}',
    cancel: 'Zrušit objednávku {0}',
    confirmChanges: 'Potvrdit a inkasovat',
  },

  labels: {
    actualOrderState: 'Aktuální stav objednávky',
    stornoHandlingFee: 'Manipulační poplatek (storno)',
    companyName: 'Název společnosti',
    companyIdNumber: 'IČ',
    companyVatNumber: 'DIČ',
    dispensing: 'Výdejna',
    takeProfit: 'Inkasovat',
    shop: 'Eko-kredity',
    settings: 'Nastavení účtu',
    clearMetadata: 'Vymazat mezipaměť',
    saveChanges: 'Vytvořit doklad',
    resetChanges: 'Zrušit změny',
    orderDate: 'Datum objednávky',
    orderState: 'Stav objednávky',
    paidAt: 'Zaplaceno',
    notPaidYet: 'Objednávka ještě nebyla zaplacena',
    ip: 'IP',
    showCustomersComments: 'Zobrazit komentáře k zákazníkovi',
    noNote: 'Zákazník nezanechal poznámku',
    noShopNote: 'Obchod nezanechal poznámku',
    showOnMap: ' Zobrazit na mapě',
    withoutWat: 'bez DPH',
    orderedItems: 'Položky objednávky',
    orderedItemsCount: '(celkem {0} produktů / {1} kusů)',
    weight: 'Váha',
    note: 'Poznámka',
    customerNote: 'Poznámka zákazníka',
    shopNote: 'Poznámka obchodu',
    info: 'Informace',
    subtotal: 'Mezisoučet',
    wat: 'DPH',
    typeOfOrder: 'Typ objednávky',
    shipping: 'Doprava',
    payment: 'Platba',
    total: 'Celkem',
    newTotal: 'Nová cena celkem',
    customer: 'Zákazník',
    notFilled: 'Nevyplněno',
    billingAddress: 'Fakturační adresa',
    shippingAddress: 'Dodací adresa',
    orderFound: 'Nalezena objednávky č.',
    goToOrder: 'Přejít na detail',
    logout: 'Odhlásit',
    send: 'Odeslat',
    customerRegistered: 'Registrovaný zákazník',
    stornoAll: 'Stornovat vše',
    orderId: 'Číslo objednávky',
    itemsCount: 'Počet položek',
    finalTaxedPrice: 'Finální celková cena',
    uploadFiles: 'Nahrát soubory',
    trackingNumber: 'Trasovací číslo',
    isPaired: 'Spárováno',
    fileName: 'Název souboru',
    date: 'Datum',
    userName: 'Jméno uživatele',
    ecoChallengeFileOrdersCount: 'Počet zásilek',
    status: 'Status',
  },

  messages: {
    noNote: 'Zákazník nezanechal poznámku',
    forSearchStartTyping: 'Pro vyhledávání začněte psát…',
    deleteConfirm: 'Opravdu si přejete smazat tuto položku',
    invalidData: 'Nevalidní data',
    fieldRequired: 'Pole je povinné',
    fieldLength: 'Pole přesahuje délku {0} znaků',
    greaterThanZero: 'Musí být větší než nula',
    lesserThan65535: 'Musí být menší než 65535',
    longerThanEight: 'Musí mít alespoň 8 znaků',
    passwordsMustMatch: 'Hesla se musejí shodovat',
    wrongEmailFormat: 'Neplatný formát e-mailu',
    messagesSent: 'Hromadná zpráva úspěšně odeslána',
    onlyHourAndMinutes: 'Zadejte pouze hodiny a minuty oddělené ":"',
    mustContainColon: 'Musí obsahovat ":"',
    passwordResetRequestSent:
      'Žádost o obnovení hesla byla odeslána, odkaz pro nastavení nového hesla vám přijde na e-mail',
    creditNoteCreated: 'Dobropis byl úspěšně vytvořen',
    accessDenied: 'Pro tuto akci nemáte oprávnění',
    greaterThan: 'Hodnota musí být větší než {0}',
    attributeCreatedSuccessfully: 'Atribut úspěšně vytvořen',
    attributeUpdatedSuccessfully: 'Atribut úspěšně upraven',
    itemMovedSuccesfully: 'Položka přemístěna úspěšně',
    noCategories: 'Zatím nemáte žádnou kategorii',
    noMoreThanTwoTags: 'K inzerátu nelze přidat více jak dva štítky',
    mustContainDialCode: 'Telefon musí obsahovat i předvolbu',
    googleSignInRequired:
      'Pro přístup k informacím je nejdříve nutné se přihlásit pomocí účtu napojeném na Google Analytics a vybrat časový interval',
    cameraNotAllowedError: 'Musíte povolit přístup ke kameře',
    cameraNotFoundError: 'Na tomto zařízeni nebyla nalezena kamera',
    cameraNotReadableError: 'Nepoužívate již kameru jinde?',
    cameraOverconstrainedError: 'Používaná kamera není vhodná',
    cameraStreamApiNotSupportedError: 'Váš prohlížeč nepodporuje toto rozhraní',
    confirmOrderChange: 'Potvrzením se vytvoří daňový doklad.',
    latestOrderChange:
      'Obj. č. <strong>{0}</strong> na <strong>{1} ks</strong> celkem za <strong>{2}</strong> úspěšně upravena. Můžete pokračovat na další objednávku. ',
    confirmOrderCancellation:
      'Potvrzením zrušíte objednávku č. <strong>{0}</strong>. <strong>Inkasovat nevratný manipulační poplatek {1}.</strong>',
    orderSuccessfullyUpdated: 'Objednávka byla úspěšně upravena',
    orderSuccessfullyCancelled: 'Objednávka byla úspěšně zrušena',
    carrier: 'Dobírka',
    successfulyCreated: 'Úspěšně vytvořeno',
    customerFound: 'Zákazník nalezen',
    customerNotFound: 'Zákazník nenalezen',
    creditsAdded: 'Úspěšně připsáno',
    invalidAmount: 'Zadejte prosím platnou hodnotu',
    successfulyCredits: 'Kredity k objednávce byly úspěšně přidány.',
    updateError: 'Byla vydána nová verze aplikace, prosím přenačtěte si stránku.',
    uploadSuccess: 'Úspěšně nahráno',
    APICallsNumberExceeded:
      'Překročili jste limit dotazů na API. Prosím vyčkejte 1 minutu pro odblokování.',
    filesAreProcessing: 'Soubory se zpracovávají',
  },

  basic: {
    yes: 'Ano',
    no: 'Ne',
    save: "Hotovo",
  },

  close: 'Zavřít',

  ecoSearch: {
    title: "Zpracování",
    input: "Vyhledávání dle ID nebo e-mailu",
    noItems: "Nenalezena žádná objednávka",
    alreadyCleared: "Tato objednávka již byla dřív zpracována - nutná asistence nadřízeného pracovníka",
    alreadyClearedMore: "Některá z vyhledávaných objednávek již byla dřív zpracována - nutná asistence nadřízeného pracovníka",
    errorStatus: 'Tato objednávka je ve stavu "Chyba", nebyla tedy korektně vytvořena.',
    badEmail: "K danému emailu neexistuje žádná aktuální objednávka (za poslední 2 měsíce) - nutná asistence nadřízeného pracovníka",
    customerNotFound: "Tohoto zákazníka nemáme v databázi.",
    list: "Nalezené nevyřízené objednávky",
    newOrder: "Nová Eko-výzva objednávka",
  },

  ecoDetail: {
    note: "Poznámka",
    records: "Poslední záznam",
    noCredits: "Aktuálně u této objednávky nejsou přidány žádné kredity.",
    creditsTitle: "Zadejte počet kreditů",
    input: "Zadejte počet kusů",
    all: "Vše",
    allCredits: "Všechny záznamy kreditů",
    credits: "Kreditů",
    save: "Uložit a zavřít",
    close: "Zavřít",
    pieces: "Kusů",
    noRights: "Nemáte oprávnění na uložení více jak 10.000 kreditů u jedné objednávy. Prosím kontaktujte podporu.",
    closePopup: "Opravdu chcete objednávku zavřít? Přijdete o všechny úpravy.",
    popupBack: "Zpět k editaci",
    popupAgree: "Ano, zavřít",
    isTooBig: "K jednomu záznamu můžete přidat maximálně 10000 kreditů.",
    oversized: "Zásilka označená jako nadrozměrná",
    noOversized: "Nadrozměrná zásilka?",
  },

  dataIterator: {
    noResultsText: 'Žádné záznamy',
    noResultsIn7Days: 'Žádné záznamy za posledních 7 dní',
    loadingText: 'Načítání...',
  },
  dataTable: {
    itemsPerPageText: 'Řádků na stránku:',
    ariaLabel: {
      activateDescending: ': Sorted descending. Activate to remove sorting.',
      activateAscending: ': Sorted ascending. Activate to sort descending.',
      activateNone: ': Not sorted. Activate to sort ascending.',
      sortDescending: ': Sorted descending. Activate to remove sorting.',
      sortAscending: ': Sorted ascending. Activate to sort descending.',
      sortNone: ': Not sorted. Activate to sort ascending.',
    },
    sortBy: 'Řadit podle',
    number: 'Číslo',
    createdAt: 'Datum',
    customerName: 'Zákazník',
    orderState: 'Status',
    paymentMethod: 'Platba',
    shippingMethod: 'Doprava',
    invoicesCount: 'Počet faktur',
    price: 'Cena',
  },
  dataFooter: {
    pageText: '{0}-{1} z {2}',
    itemsPerPageText: 'Položek na stránku:',
    itemsPerPageAll: 'Vše',
    nextPage: 'Další stránka',
    prevPage: 'Předchozí stránka',
    firstPage: 'První stránka',
    lastPage: 'Poslední stránka',
  },
  fileInput: {
    counter: 'Vybráno celkem souborů: {0}',
  },
  noDataText: 'Nejsou dostupná žádná data',
  searchOrder: {
    id: 'Číslo objednávky',
    customerName: 'Jméno zákazníka',
    companyName: 'Název společnosti',
    email: 'E-mail',
    phone: 'Telefon',
    createdAtFrom: 'Vytvoření objednávky - od',
    createdAtTo: 'Vytvoření objednávky - do',
    shippingMethod: 'Způsob dopravy',
    shippingOption: 'Pobočka',
    paymentMethod: 'Způsob platby',
    status: 'Stav objednávky',
    priceProm: 'Cena od',
    priceTo: 'Cena do',
    country: 'Země',
    productName: 'Název produktu',
    brandName: 'Výrobce produktu',
    productSKU: 'SKU produktu',
    productEan: 'EAN produktu',
    packageNumber: 'Číslo zásilky',
    customerGroup: 'Zákaznická skupina',
    filter: 'Filtrovat',
    delete_filter: 'Resetovat filtry',
    status_all: 'Nerozhoduje',
    status_active: 'Aktivní',
    status_inactive: 'Neaktivní',
  },

  ecoChallengeType: {
    0: 'Sklad',
    1: 'Penguin',
    2: 'Prodejna',
    3: 'Zásilkovna',
    4: 'Česká Pošta - Balíkovna',
    5: 'Svoz na adrese',
  },

  ecoChallengeStatus: {
    Discard: 'Zrušeno',
    Collected: 'Zpracovává se',
    WaitForReturn: 'Čeká se na balík',
    WaitForCollect: 'Dopravuje se',
    GenesisCreditsAdded: 'Kredity připsány',
    GenesisProcessingOrder: 'Čeká se na vyřízení objednávky',
    GenesisSendingToThirdPartiesApi: 'Chyba',
    GenesisWaitingForRegistration: 'Čeká se na registraci',
    ToBePaid: 'Čeká se na zaplacení',
  },

  ecoChallengeList: {
    title: 'Objednávky',
    input: 'Hledejte dle externího ID, emailu, jména nebo příjmení',
    id: 'Externí ID',
    consignment_code: 'Kód zásilky',
    created: 'Vytvořeno',
    customer: 'Zákazník',
    transport: 'Doprava',
    status: 'Stav',
    name: 'Jméno',
    surname: 'Příjmení',
    email: 'Email',
    type: 'Typ dopravy',
  },

  ecoChallengeDetail: {
    title: 'Detail objednávky',
    status: 'Stav',
    note: 'Poznámka',
    transport: 'Typ dopravy',
    created: 'Vytvořeno',
    brought: 'Přineseno',
    updated: 'Upraveno',
    invoice: 'Faktura',
    items: 'Položky',
    overall: '(celkem',
    products: 'produktů /',
    pieces: 'kusů)',
    amount: 'Počet položek',
    number: 'Počet kreditů',
    credits: 'Množství kreditů',
    transit: 'Doprava',
    oversized: 'Pokuta za nadměrnou zásilku',
    included: 'započtena v dopravě',
    total: 'Celkem kreditů',
    address: 'Adresa',
    billingAddress: 'Fakturační adresa',
  },

  shipments: {
    title: 'Příjem Zásilkovny',
    reported: 'Hlášeno',
    shipments: 'zásilek',
    scanned: 'načteno',
    missingShipments: 'chybějící zásilky',
  },

  files: {
    title: 'Provedené kontroly',
    created: 'Vytvořeno',
    processing: 'Zpracovává se',
    processed: 'Zpracováno',
  }
};
